import { useEffect } from 'react';
import authService from '../authentication/AuthorizeService';
import getAnalyticsConfiguration from './webAnalyticsService';

const PendoTracker = () => {
  useEffect(() => {
    async function renderPendo() {
      const userProfile = await authService.getUserProfile();
      if (userProfile === null || userProfile.personguid === '') {
        return null;
      }
      const visitorId = userProfile.personguid;
      const accountId = userProfile.tenant;

      const analyticsData = await getAnalyticsConfiguration(false);

      const analyticUrl = analyticsData.webAnalyticSiteUrl;
      const apiKey = analyticsData.webAnalyticSiteID;
      const pendoEnabled = analyticsData.webAnalyticIsEnable === '1';

      // only load the Pendo source and Initialization when Pendo has been enabled for the tenant
      if (pendoEnabled === true) {
        // script used to load the pendo resource
        // this script is not in a seperate file, as it's using some variables that must first be obtained via webanalytic service call
        const pendoSourceScript = `var p = window; var e = document; var n = 'script'; var d='pendo'; var o; var apikey ='${apiKey}'; var url = '${analyticUrl}'; var v, w, x, y, z; o = p[d] = p[d] || {}; o._q = o._q || []; v = ['initialize', 'identify', 'updateOptions', 'pageLoad', 'track']; for (w = 0, x = v.length; w < x; ++w)(function (m) { o[m] = o[m] || function () { o._q[m === v[0] ? 'unshift' : 'push']([m].concat([].slice.call(arguments, 0))); }; })(v[w]);    y = e.createElement(n); y.async = !0; y.src = url + '/' + apikey + '/pendo.js';    z = e.getElementsByTagName(n)[0]; z.parentNode.insertBefore(y, z);`;
        const pendoLoadScript = document.createElement('script');
        pendoLoadScript.type = 'text/javascript';
        pendoLoadScript.async = true;
        pendoLoadScript.innerHTML = pendoSourceScript;
        document.body.appendChild(pendoLoadScript);

        // script for initializing Pendo using logged in user's details
        const pendoInitScript = document.createElement('script');
        pendoInitScript.type = 'text/javascript';
        pendoInitScript.async = true;
        pendoInitScript.innerHTML = `pendo.initialize({visitor: {id:'${visitorId}',evtSource:'rcore'},account: {id:'${accountId}'}}); `;
        document.body.appendChild(pendoInitScript);
      }
    }
    renderPendo();
  }, []);
  return null;
};
export default PendoTracker;
